export default "__VITE_ASSET__D1YDy213__"